import { Modal } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/es';
import React from 'react';
import Button from '../Button';

const EMPTY_VALUE = 'No informado';

export const formatMeetingDate = (schedule) => {
  const date = moment(schedule, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);

  if (!date.isValid()) return schedule || EMPTY_VALUE;

  const formattedDate = date.format('dddd D [de] MMMM [de] YYYY, HH:mm');
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

const SummaryItem = ({ label, value, wide = false }) => (
  <div
    className={`meeting-confirmation__item${
      wide ? ' meeting-confirmation__item--wide' : ''
    }`}
  >
    <dt>{label}</dt>
    <dd>{value || EMPTY_VALUE}</dd>
  </div>
);

const MeetingSummaryModal = ({
  open,
  onCancel,
  onAccept,
  isSubmitting = false,
  mentor,
  participant,
  pillar,
  schedules = [],
  frequency,
  totalSessions,
  subject,
  description,
  guestEmails = [],
}) => {
  const handleCancel = () => {
    if (!isSubmitting) onCancel();
  };

  const handleAccept = () => {
    if (!isSubmitting) onAccept();
  };

  const sessionCount = totalSessions || schedules.length;

  return (
    <Modal
      className="meeting-confirmation-modal"
      open={open}
      onClose={handleCancel}
      disableEscapeKeyDown={isSubmitting}
    >
      <div
        className="meeting-confirmation"
        role="dialog"
        aria-modal="true"
        aria-labelledby="meeting-confirmation-title"
        aria-describedby="meeting-confirmation-description"
      >
        <header className="meeting-confirmation__header">
          <span>Revisión final</span>
          <h2 id="meeting-confirmation-title">Resumen de reuniones</h2>
          <p id="meeting-confirmation-description">
            Revisa la información antes de agendar. Las invitaciones se enviarán
            automáticamente a los participantes.
          </p>
        </header>

        <div
          className="meeting-confirmation__content"
          role="region"
          aria-label="Contenido del resumen de reuniones"
          tabIndex={0}
        >
          <dl className="meeting-confirmation__details">
            <SummaryItem label="Mentor" value={mentor} />
            <SummaryItem label="Mentee" value={participant} />
            <SummaryItem label="Pilar" value={pillar} />
            <SummaryItem label="Frecuencia" value={frequency} />
            <SummaryItem
              label="Cantidad total"
              value={`${sessionCount} ${
                sessionCount === 1 ? 'sesión' : 'sesiones'
              }`}
            />
            <SummaryItem label="Asunto" value={subject} />
            <SummaryItem label="Descripción" value={description} wide />
          </dl>

          <section
            className="meeting-confirmation__section"
            aria-labelledby="meeting-confirmation-schedules"
          >
            <div className="meeting-confirmation__section-header">
              <h3 id="meeting-confirmation-schedules">
                Fechas y horarios programados
              </h3>
              <span>{sessionCount}</span>
            </div>
            <ol className="meeting-confirmation__schedule-list">
              {schedules.map((schedule, index) => (
                <li key={`${schedule}-${index}`}>
                  <span>Sesión {index + 1}</span>
                  <time dateTime={String(schedule).replace(' ', 'T')}>
                    {formatMeetingDate(schedule)} hrs.
                  </time>
                </li>
              ))}
            </ol>
          </section>

          <section
            className="meeting-confirmation__section"
            aria-labelledby="meeting-confirmation-guests"
          >
            <div className="meeting-confirmation__section-header">
              <h3 id="meeting-confirmation-guests">Invitados adicionales</h3>
              <span>{guestEmails.length}</span>
            </div>
            {guestEmails.length ? (
              <ul className="meeting-confirmation__guest-list">
                {guestEmails.map((email) => (
                  <li key={email}>{email}</li>
                ))}
              </ul>
            ) : (
              <p className="meeting-confirmation__empty">
                Sin invitados adicionales
              </p>
            )}
          </section>
        </div>

        <footer className="meeting-confirmation__footer">
          {isSubmitting && (
            <p role="status" aria-live="polite">
              Agendando reuniones. Por favor, espera…
            </p>
          )}
          <div className="meeting-confirmation__actions">
            <Button
              type="button"
              secondary
              disabled={isSubmitting}
              onClick={handleCancel}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              loading={isSubmitting}
              disabled={isSubmitting}
              onClick={handleAccept}
            >
              Aceptar
            </Button>
          </div>
        </footer>
      </div>
    </Modal>
  );
};

export default MeetingSummaryModal;
